import React from 'react';
import CustomModal from '../../components/Modal/CustomModal';
import ButtonAction from '../../components/buttons/ButtonAction';
import {AddIcon, CleanIcon, EyeIcon, SearchAdvanceIcon} from '../../components/buttons/IconButtons';
import SearchForApp from './Functionality/SearchForApp';
import ConnectorToggle from './SearchFor/SubComponents/ConnectorToggle';
import RuleGroup from './SearchFor/SubComponents/RuleGroup';
import { ITEM_TYPE_MODEL } from './SearchFor/Model/Model';
import ButtonIcon from "../../components/buttons/ButtonIcon";

const SearchFor = (props) => {
    const {
        open,
        onClose,
        onFiltered,
        moduleId,
        option,
        finalArray,
        modelType,
        setSearch,
        cleanAdvance,
        setCleanAdvance,
        cleanRules,
        setFinalArray,
        searchElement,
        userId = null,
        noShowFilters = null,
        callGetValuesApi = null,
    } = props;

    const {
        t,
        items,
        attributesFilter,
        summaryVisible,
        handleAddGroup,
        handleDeleteItem,
        handleAddRuleToGroup,
        handleDeleteRuleFromGroup,
        handleAddTopLevelRule,
        handleFieldChange,
        handleConditionChange,
        handleValueChange,
        handleDateChange,
        handleFromDateChange,
        handleToDateChange,
        handleRangeValueChange,
        handleAssignMultiple,
        handleValidityChange,
        handleItemConnectorChange,
        handleRuleConnectorChange,
        handleSearch,
        handleClear,
        summary,
        renderStandaloneRule
    } = SearchForApp({
        open,
        onFiltered,
        moduleId,
        option,
        finalArray,
        modelType,
        setSearch,
        cleanAdvance,
        setCleanAdvance,
        cleanRules,
        setFinalArray,
        searchElement,
        userId,
        noShowFilters,
        callGetValuesApi,
    });

    return (
        <CustomModal
            show={open}
            title=""
            size="lx"
            buttonConfirm="confirm"
            cancelButton={true}
            confirmButton={true}
            onConfirm={handleSearch}
            onHide={onClose}
            classNameBody="p-0 m-0 w-100"
            topLeftHeader={
                <>
                    <div className={"d-flex align-items-center mb-3"}>
                        <SearchAdvanceIcon width={24} height={24}/>
                        <p className={"fs-modal-title font-color-general-950 ibl-font-w-600 mx-2"}>{t("advanced_search")}</p>
                        <ButtonIcon
                            id='btn_sf_clean'
                            Icon={CleanIcon}
                            onClick={handleClear}
                            title={'clear_instances'}
                            className={"btn-clean-secondary-600"}
                            tooltipPlacement={"right"}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    </div>
                    { summary && summaryVisible &&
                    <div className={"background-shades-100 border-top-left-right-shades-300 border-radius-top-8px p-3 w-100"}>
                        <div className={"d-flex align-items-center mb-2"}>
                            <div className={"h-32px w-32px d-flex justify-content-center align-items-center border-radius-50 background-shades-700"}>
                                <EyeIcon className={"icon-color-general-00"}/>
                            </div>
                            &nbsp;&nbsp;
                            <p className={"font-color-shades-600 ibl-font-w-600 fs-18px"}>{t("search_preview")}</p>
                        </div>
                        <p className={"font-color-shades-600 ibl-font-w-500 fs-14px"}>
                            {summary}
                        </p>
                    </div>
                    }
                </>
            }
        >
            <div className={`border-full-shades-300 p-3 ${summary && summaryVisible ? 'border-radius-bottom' : 'border-radius-8px'}`}>
                {items.map((item, idx) => (
                    <React.Fragment key={item.id}>
                        {idx > 0 && (
                            <ConnectorToggle
                                connector={item.connector}
                                onChange={(c) => handleItemConnectorChange(item.id, c)}
                            />
                        )}

                        {item.type === ITEM_TYPE_MODEL.GROUP ? (
                            <RuleGroup
                                group={item}
                                attributesFilter={attributesFilter}
                                onDeleteGroup={() => handleDeleteItem(item.id)}
                                onAddRule={() => handleAddRuleToGroup(item.id)}
                                onDeleteRule={(ruleId) => handleDeleteRuleFromGroup(item.id, ruleId)}
                                onRuleConnectorChange={(ruleId, c) => handleRuleConnectorChange(item.id, ruleId, c)}
                                onFieldChange={(ruleId, fId) => handleFieldChange(item.id, ruleId, fId)}
                                onConditionChange={(ruleId, cId, opKey, rule) => handleConditionChange(item.id, ruleId, cId, opKey, rule)}
                                onValueChange={(ruleId, val) => handleValueChange(item.id, ruleId, val)}
                                onDateChange={(ruleId, date) => handleDateChange(item.id, ruleId, date)}
                                onFromDateChange={(ruleId, date) => handleFromDateChange(item.id, ruleId, date)}
                                onToDateChange={(ruleId, date) => handleToDateChange(item.id, ruleId, date)}
                                onFromValueChange={(ruleId, val) => handleRangeValueChange(item.id, ruleId, 'fromValue', val)}
                                onToValueChange={(ruleId, val) => handleRangeValueChange(item.id, ruleId, 'toValue', val)}
                                onAssignMultiple={(ruleId, selectedIds, rule) => handleAssignMultiple(item.id, ruleId, selectedIds, rule)}
                                onValidityChange={(ruleId, field, val) => handleValidityChange(item.id, ruleId, field, val)}
                            />
                        ) : (
                            renderStandaloneRule(item)
                        )}
                    </React.Fragment>
                ))}
                <div className="d-flex mt-3 gap-12px">
                    <ButtonAction
                        id="btn_sf_add_rule"
                        name="add_rule"
                        className="btn-outlined-secondary-600-00"
                        disabled={false}
                        splitName={false}
                        onClick={handleAddTopLevelRule}
                        Icon={AddIcon}
                    />
                    <ButtonAction
                        id="btn_sf_add_group"
                        name="add_group"
                        className="btn-outlined-secondary-600-00"
                        disabled={false}
                        splitName={false}
                        onClick={handleAddGroup}
                        Icon={AddIcon}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default SearchFor;
